import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import {Flex, Tabs} from "antd";
import MyText from "../../../../components/UI/Text/MyText";
import CreateUsers from "./Creation/CreateUsers";
import TeachersList from "./List/TeachersList";
import StudentsList from "./List/StudentsList";
import {getAllTeachersPageable} from "../../../../store/slices/TeachersListSlice";
import {getAllStudentsPageable} from "../../../../store/slices/StudentsListSlice";
import {getAllMEditorsPageable} from "../../../../store/slices/MEditorsListSlice";
import MEditorsList from "./List/MEditorsList";


const UsersPage = () => {
    const dispatch = useDispatch();
    const teachers = useSelector(state => state.teachersListTableController);
    const students = useSelector(state => state.studentsListTableController);
    const mEditors = useSelector(state => state.mEditorsListTableController);

    const onChangeTabs = async (key) => {
        if (key === '1') {
            dispatch(getAllTeachersPageable({
                page: teachers?.currentPage,
                limit: teachers?.pageSize,
                isGroupsNeeded: true
            }));
        }
        if (key === '2') {
            dispatch(getAllStudentsPageable({
                page: students?.currentPage,
                limit: students?.pageSize,
                isGroupsNeeded: true
            }));
        }
        if (key === '3') {
            dispatch(getAllMEditorsPageable({
                page: mEditors?.currentPage,
                limit: mEditors?.pageSize
            }));
        }
    };

    const tabItems = [
        {
            key: '1',
            label: <IntlMessage id={'teachersList'}/>,
            children: <TeachersList/>,
        },
        {
            key: '2',
            label: <IntlMessage id={'studentsList'}/>,
            children: <StudentsList/>,
        },
        {
            key: '3',
            label: <IntlMessage id={'mEditorsList'}/>,
            children: <MEditorsList/>,
        },
        {
            key: '4',
            label: <IntlMessage id={'create'}/>,
            children: <CreateUsers/>,
        },
    ]

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <MyText uppercase strong size={"large"}><IntlMessage id={'users'}/></MyText>
            <Tabs style={{width: "100%"}} defaultActiveKey={"1"} type="card" items={tabItems} onChange={onChangeTabs}/>
        </Flex>
    );
};

export default UsersPage;